import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useInbox } from "../api/alerts.js";
import { alertText } from "../pages/alerts/text.js";
import { useToast } from "../ui/toast.js";

/*
 * In-panel alert notifications (docs/alerts.md): a short notice when a new
 * alert reaches the person while the panel is open. The list is on
 * «Настройки уведомлений»; the top-bar bell (docs/budgets.md) stays the one
 * counter of the panel.
 */

/** Shows a notice for each alert that reaches the person while the panel is open. */
export function AlertToasts() {
  const { t, i18n } = useTranslation();
  const inbox = useInbox();
  const toast = useToast();
  const seen = useRef<Set<string> | null>(null);
  useEffect(() => {
    const items = inbox.data?.items;
    if (!items) return;
    // What was there when the panel opened is not news.
    if (seen.current === null) {
      seen.current = new Set(items.map((i) => i.id));
      return;
    }
    const fresh = items.filter((i) => !seen.current?.has(i.id) && !i.readAt && i.phase === "fired");
    for (const item of items) seen.current.add(item.id);
    const [first] = fresh;
    if (!first) return;
    const where = first.alert.serverName ?? first.alert.projectName;
    toast({
      tone: "info",
      title: t("alerts.toast.new"),
      detail:
        fresh.length > 1
          ? t("alerts.toast.several", { n: fresh.length })
          : `${where}: ${alertText(t, first.alert, i18n.language)}`,
    });
  }, [inbox.data, t, i18n.language, toast]);
  return null;
}
